import { DSNewsletterPage, DSRedirect, DSResource } from 'shared-definitions/types'
import {
  ApiComponent,
  ApiNewsletterFeedProps,
  ApiResponse,
  ApiResponseRedirect,
} from 'data-source/types.wp'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import {
  newsletterButtonMapper,
  NewsletterButtonMapperOpts,
} from 'data-source/mappers/newsletterButtonMapper'
import { redirectMapper } from 'data-source/mappers/redirectMapper'

interface CodecGetNewsletterPageOpts<T extends DSResource, A extends ApiComponent>
  extends NewsletterButtonMapperOpts,
    MetaMapperOpts {
  pagePath: string
  ampPagePath: null | string
  componentItemMapper: (input: A) => T | T[]
}

export function codecGetNewsletterPage<T extends DSResource, A extends ApiComponent>(
  raw: ApiResponse<ApiNewsletterFeedProps<A>> | ApiResponseRedirect,
  opts: CodecGetNewsletterPageOpts<T, A>
): DSNewsletterPage<T> | DSRedirect | null {
  if ('redirect' in raw) {
    return redirectMapper(raw)
  }
  if (!('data' in raw)) {
    return null
  }
  if (!('content' in raw.data)) {
    return null
  }

  const input = raw.data

  const nextButton = input.next_newsletter
    ? newsletterButtonMapper(input.next_newsletter, input.newsletter, opts)
    : null

  const prevButton = input.previuos_newsletter
    ? newsletterButtonMapper(input.previuos_newsletter, input.newsletter, opts)
    : null

  return {
    head: headPropsMapper(input.head),
    pagePath: opts.pagePath,
    sections: null,
    ampPagePath: opts.ampPagePath,
    title: input.content.title,
    resource: 'newsletter-page',
    meta: metaMapper(input, [input.content.title], opts),
    blocks: input.content.content.flatMap(opts.componentItemMapper),
    date: input.content.date,
    image: imageMapper(input.newsletter.image, opts),
    buttons: [
      ...(prevButton
        ? [
            {
              ...prevButton,
              type: 'prev',
            } as const,
          ]
        : []),
      ...(nextButton
        ? [
            {
              ...nextButton,
              type: 'next',
            } as const,
          ]
        : []),
    ],
  }
}
